import { render, staticRenderFns } from "./FeatureFlagSwitcherQueueBuster.vue?vue&type=template&id=56d3ea11"
import script from "./FeatureFlagSwitcherQueueBuster.vue?vue&type=script&lang=js"
export * from "./FeatureFlagSwitcherQueueBuster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports